var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "url(#paint0_linear_1626_684)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0203 17.6556C18.2459 16.9344 17.3536 16.195 17.3536 15.0339C17.3536 13.7017 18.582 12.7667 20.6536 12.7667C22.8292 12.7667 23.6359 13.8056 23.7092 15.3333H26.4103C26.3308 13.225 25.0414 11.3061 22.487 10.6767V8H18.8203V10.64C16.4492 11.1594 14.5425 12.6872 14.5425 15.0522C14.5425 17.8756 16.8831 19.2811 20.287 20.1C23.3486 20.8333 23.9536 21.9028 23.9536 23.0517C23.9536 23.8889 23.3609 25.2333 20.6536 25.2333C18.1359 25.2333 17.1397 24.1028 17.0114 22.6667H14.3164C14.4692 25.3433 16.4675 26.8406 18.8203 27.3478V30H22.487V27.3722C24.8642 26.9139 26.7647 25.5389 26.7647 23.0272C26.7647 19.5683 23.7947 18.3828 21.0203 17.6556Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1626_684",
    x1: 16.0428,
    y1: 3.64966e-7,
    x2: 2.14851,
    y2: 35.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9105FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.ec281508cd4808b806f928af95989ec4.svg";
export { ForwardRef as ReactComponent };